import React from 'react';
import {Comment, Button} from 'semantic-ui-react';
import Moment from 'moment';

const ChatSpeechMenuRedirect = (props) => {
    return (
        <Comment>
            <Comment.Avatar src='https://incomeapp.mhc.asia/static/app_logo.png' />
            <Comment.Content>
                <Comment.Author as='a'>Joey</Comment.Author>
                <Comment.Metadata>
                    <div>{ Moment().format('Do MMM YYYY HH:MM:SS') }</div>
                </Comment.Metadata>
                <Comment.Text>{props.message}</Comment.Text>
                <Button
                    fluid
                    onClick={() => props.redirectPageToUrl(props.actionParam.webUrl)}
                >
                    {props.actionParam.buttonText}
                </Button>
            </Comment.Content>
        </Comment>
    );
}

export default ChatSpeechMenuRedirect;
